module.exports = __webpack_public_path__ + "img/sy.e8f12fd9.png";